import cn from 'classnames';
import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
  isPadding?: boolean;
  isFullWidth?: boolean;
}

export const Container = ({ children, className, isPadding = false, isFullWidth = true }: Props) => (
  <div className={cn('mx-auto w-full', { 'px-4 md:px-10': isPadding, 'max-w-[1350px]': isFullWidth }, className)}>
    {children}
  </div>
);
